import Inputmask from 'inputmask/dist/inputmask.es6'
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker'
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.pt-BR.min'
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.es.min'
import { getUserLang } from '@/plugins/lang'
import { dateFormat } from '@/helpers/dateHelper'

let lang = getUserLang()

let els = $('.datepicker')

els.each(function() {
    let format, placeholder, minViewMode

    if (this.className.includes('month-year')) {
        format = dateFormat().inputMask.monthYear
        placeholder = dateFormat().placeholder.monthYear
        minViewMode = 1
    } else {
        format = dateFormat().inputMask.date
        placeholder = dateFormat().placeholder.date
    }

    $(this).datepicker({
        language: lang,
        format,
        minViewMode,
        todayHighlight: true
    });

    Inputmask({
        alias: 'datetime',
        inputFormat: format,
        placeholder: placeholder,
        clearMaskOnLostFocus: false,
        autoUnmask: true,
        removeMaskOnSubmit: true,
    }).mask(this)
})
